export const THEME_PRESETS = ['blaze', 'lightspeed'] as const;
export type ThemePreset = (typeof THEME_PRESETS)[number];
export const DEFAULT_THEME_PRESET: ThemePreset = 'blaze';

export const THEME_PRESET_LABELS: Record<ThemePreset, string> = {
  blaze: 'BlazePOS',
  lightspeed: 'Lightspeed',
};

export const THEME_PRESET_DESCRIPTIONS: Record<ThemePreset, string> = {
  blaze:
    'Default BlazePOS look — vertical sidebar, orange accent, rounded surfaces.',
  lightspeed:
    'Lightspeed Retail X-Series look — horizontal top nav, teal accent, dense layouts.',
};

export function isThemePreset(value: unknown): value is ThemePreset {
  return (
    typeof value === 'string' &&
    (THEME_PRESETS as readonly string[]).includes(value)
  );
}

export function resolvePreset(value: unknown): ThemePreset {
  return isThemePreset(value) ? value : DEFAULT_THEME_PRESET;
}

interface OrgSettingsShape {
  appearance?: { preset?: unknown };
}

export function extractPreset(settings: unknown): ThemePreset {
  if (!settings || typeof settings !== 'object') return DEFAULT_THEME_PRESET;
  const presetValue = (settings as OrgSettingsShape).appearance?.preset;
  return resolvePreset(presetValue);
}
